import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {take} from "rxjs";
import {DateTime} from "luxon";
import {DealActions} from "../store/deal.actions";
import {selectSelectedDeal} from "../store/deal/deal.selectors";
import {DateUtil} from "../../shared/utils/date-util";
import {noWhitespaceValidator} from "../../shared/utils/form-validators";

@Component({
    selector: "valumize-deal-copy-dialog",
    templateUrl: "./deal-copy-dialog.component.html",
    styleUrls: ["./deal-copy-dialog.component.scss"],
    standalone: false
})
export class DealCopyDialogComponent implements OnInit {

    private readonly store = inject(Store);
    private readonly formBuilder = inject(FormBuilder);

    dealId?: number;

    copyForm = this.formBuilder.group({
        closingDate: this.formBuilder.control<Date>(DateTime.now().toJSDate(), {nonNullable: true, validators: [Validators.required]}),
        projectName: this.formBuilder.control<string>("", {nonNullable: true, validators: [Validators.required, Validators.maxLength(100), noWhitespaceValidator()]})
    });

    ngOnInit(): void {
        this.store.select(selectSelectedDeal).pipe(take(1)).subscribe((deal) => {
            this.dealId = deal.id;
            this.copyForm.patchValue({
                closingDate: DateUtil.fromIsoDate(deal.closingDate?.date)?.toJSDate() ?? DateTime.now().toJSDate(),
                projectName: deal.projectName?.text ? `${deal.projectName.text} (Copy)` : ""
            });
        });
    }

    copyDeal(): void {
        if (this.copyForm.valid && this.dealId != null) {
            const formValues = this.copyForm.getRawValue();
            this.store.dispatch(DealActions.copy({
                dealId: this.dealId,
                closingDate: DateUtil.toIsoDate(formValues.closingDate) as string,
                projectName: formValues.projectName
            }));
        }
    }
}
